export default __webpack_public_path__ + "static/media/planet1.4731f5fb.png";